import Image from "next/image";

export default function Avatar({width, height, url = "/logo_variant.svg"}){
    return <img src={url} alt={"avatar"} width={width} height={height} className={"aspect-square object-cover object-center rounded-full"}/>
}